import React, { useState, useEffect } from "react";
import { deleteOrder, getOrders, getOrderItems, addOrder, addOrderItem, updateOrder } from "../api/api";
import ResponseDialog from "./dialog/ResponseDialog";

function roundTo(number, multiple) {
    return Math.round(number / multiple) * multiple
}

function decodeStringFromUrl(str) {
  if (typeof str !== "string") return "";
//   let decoded = decodeURIComponent(str);
  return str
    .replace(/%2F/g, "/")
    .replace(/%82/g, ",")
    .replace(/%3B/g, ";")
    .replace(/%3A/g, ":")
    .replace(/%3D/g, "=")
    .replace(/%20/g, " ");
}

const Orders = () => {
    const [okmessage, setOKmessage] = useState("");
    const [orders, setOrders] = useState([]);
    const [orderItems, setOrderItems] = useState([]);
    const [id, setId] = useState("");
    const [num, setNum] = useState("");
    const [date, setDate] = useState("");
    const [description, setDescription] = useState("");
    const [trackingNumber, setTrackingNumber] = useState("");
    const [trackingLink, setTrackingLink] = useState("");
    const [quantity, setQuantity] = useState(0);
    const [price, setPrice] = useState(0);
    const [percent, setPercent] = useState(15);
    const [delivered, setDelivered] = useState(0);
    const [collected, setCollected] = useState(0);

    const loadOrders = async (alert) => {
        const response = await getOrders();
        if (alert) {
            setOKmessage(response.status === 200 ? "Orders loaded successfully" : response.message + ": Error loading orders");
        }
        setOrders(response.data.data.getOrderListing.edges);
    };

    const loadOrderItems = async (orderNUM) => {
        const response = await getOrderItems(orderNUM);
        setOKmessage(response.status === 200 ? "Order items loaded successfully" : response.message + ": Error loading order items");
        setOrderItems(response.data.data.getOrderItemListing.edges);
    };

    const handleDelete = async (orderID) => {
        if (!window.confirm("Are you sure you want to delete this order?")) {
            return; // User cancelled the deletion
        }
        setOKmessage("Deleting order...");
        const formData = orderID;
        try {
            const response = await deleteOrder(formData);
            setOKmessage(response.status === 200 ? "Order deleted successfully" : response.message + ": Error deleting order");
            loadOrders(0); // Ricarica la lista degli ordini
        } catch (error) {
            setOKmessage("Error deleting order");
        }
    };

    const handleCreate = async (e) => {
        e.preventDefault();
        const formData = { num, date };
        try {
            const response = await addOrder(formData);
            setOKmessage(response.status === 200 ? "Order added successfully" : response.message + ": Error adding order");
            setNum("");
            setDate("");
            loadOrders(0); // Ricarica la lista degli ordini
        } catch (error) {
            setOKmessage("Error adding order");
        }
    };

    const handleCreateItem = async (e) => {
        e.preventDefault();
        const formData = { id, description, quantity, price, trackingNumber, trackingLink, delivered, collected, percent };
        try {
            const response = await addOrderItem(formData);
            setOKmessage(response.status === 200 ? "Order item added successfully" : response.message + ": Error adding order item");
            // setNum("");
            setDate("");
            loadOrderItems(num); // Ricarica la lista degli item dell'ordine
            setDescription("");
            setTrackingNumber("");
            setTrackingLink("");
            setQuantity(0);
            setPrice(0);
            setPercent(15);
            setDelivered(0);
            setCollected(0);
        } catch (error) {
            setOKmessage("Error adding order");
        }
    };

    const handleUpdate = async (e) => {
        e.preventDefault();
        const formData = { id, num, date };
        try {
            const response = await updateOrder(formData);
            setOKmessage(response.status === 200 ? "Order updated successfully" : response.message + ": Error updating order");
            setNum("");
            setDate("");
            loadOrders(0); // Ricarica la lista degli ordini
        } catch (error) {
            setOKmessage("Error updating order");
        }
    };

    useEffect(() => {
        setOKmessage("Loading orders...");
        loadOrders(1);
    }, []);

    return (
        <div>
            <div className="card">
                <div className="card-header">
                    <h5>Orders list</h5>
                    <div className="card-header-right">
                        <div className="btn-group card-option">
                            <button type="button" className="btn dropdown-toggle" data-toggle="modal" data-target="#modalAddOrder" aria-haspopup="true" aria-expanded="false">
                                <i className="material-symbols-outlined">add</i>
                            </button>
                        </div>
                    </div>
                    <span className="d-block m-t-5">list of <code>orders</code> and totals of their elements</span>
                </div>
                <div className="card-body table-border-style">
                    {okmessage && <ResponseDialog message={okmessage} onClose={() => setOKmessage("")} />}
                    <div className="table-responsive">
                        <table className="table">
                            <thead>
                                <tr>
                                    <th>Num</th>
                                    <th>Date</th>
                                    {/* <th>Discount</th> */}
                                    <th>Total</th>
                                    <th>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {orders.map((order, index) => (
                                    order = order.node,
                                    <tr key={index}>
                                        <td>{order.num}</td>
                                        <td>{new Date(order.date).toLocaleDateString("it-IT")}</td>
                                        {/* <td>{order.discount || 0}</td> */}
                                        <td>
                                            <span className="badge badge-pill badge-secondary" data-toggle="tooltip" data-placement="top" data-original-title="Total items">{order.totalQuantity || 0}</span>
                                            <span className="badge badge-pill badge-info" data-toggle="tooltip" data-placement="top" data-original-title="Total price in">€ {(order.totalPriceIN || 0).toFixed(2)}</span>
                                            <span className="badge badge-pill badge-info" data-toggle="tooltip" data-placement="top" data-original-title="Total price out">€ {(order.totalPriceOUT || 0).toFixed(2)}</span>
                                            {(order.totalReturned > 0) &&
                                                <span className="badge badge-pill badge-dark" data-toggle="tooltip" data-placement="top" data-original-title="Total returned"> {(order.totalReturned || 0).toFixed(2)}</span>
                                            }
                                        </td>
                                        <td>
                                            <button
                                                type="button"
                                                className="btn m-0 p-0"
                                                data-toggle="tooltip"
                                                data-placement="top"
                                                data-original-title="Delete order"
                                                onClick={() => handleDelete(order.id)}
                                            >
                                                <span className="badge badge-pill badge-light-info">
                                                    <span style={{ fontSize: '12px' }} className="material-symbols-outlined">delete</span>
                                                </span>
                                            </button>
                                            <button
                                                type="button"
                                                className="btn m-0 p-0"
                                                data-toggle="tooltip"
                                                data-placement="top"
                                                data-original-title="Edit order"
                                                onClick={() => {
                                                    setId(order.id);
                                                    setNum(order.num);
                                                    setDate(new Date(order.date).toLocaleDateString("sv-SE"));
                                                    // setDiscount(order.discount);
                                                }}
                                            >
                                                <span className="badge badge-pill badge-light-info" data-toggle="modal" data-target="#modalUpdateOrder"><span style={{ fontSize: '12px' }} className="material-symbols-outlined">edit</span></span>
                                            </button>
                                            <button
                                                type="button"
                                                className="btn m-0 p-0"
                                                data-toggle="tooltip"
                                                data-placement="top"
                                                data-original-title="View order items"
                                                onClick={() => {
                                                    setId(order.id);
                                                    setNum(order.num);
                                                    loadOrderItems(order.num);
                                                }}
                                            >
                                                <span className="badge badge-pill badge-light-info" data-toggle="modal" data-target="#modalViewOrderItems"><span style={{ fontSize: '12px' }} className="material-symbols-outlined">view_headline</span></span>
                                            </button>
                                            {/* <a href={`/orders/${order.id}/elements`}>
                                                <button type="button" className="btn m-0 p-0" data-toggle="tooltip" data-placement="top" data-original-title="View order items">
                                                    <span className="badge badge-pill badge-light-info"><span style={{ fontSize: '12px' }} className="material-symbols-outlined">view_headline</span></span>
                                                </button>
                                            </a> */}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

            {/* MODAL ADD ORDER */}
            <div className="modal fade" id="modalAddOrder" tabIndex={-1} role="dialog" style={{ display: 'none' }}>
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title h4" id="myLargeModalLabel">Add order</h5>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close"><span>×</span></button>
                        </div>
                        <div className="modal-body">
                            <form id="formAddOrder" method="post" onSubmit={handleCreate}>
                                <div className="form-row">
                                    <div className="col-md-4 mb-3">
                                        <label htmlFor="ordersNum">Number</label>
                                        <input type="text" className="form-control" name="num" placeholder="Numero" required
                                            value={num}
                                            onChange={(e) => setNum(e.target.value)}
                                        />
                                    </div>
                                    <div className="col-md-4 mb-3">
                                        <label htmlFor="ordersDate">Date</label>
                                        <input type="date" className="form-control" name="date" required
                                            value={date}
                                            onChange={(e) => setDate(e.target.value)}
                                        />
                                    </div>
                                    {/* <div className="col-md-4 mb-3">
                                        <label htmlFor="ordersDiscount">Discount</label>
                                        <input type="number" className="form-control" name="discount" placeholder="Sconto" required
                                            value={discount}
                                            onChange={(e) => setDiscount(e.target.value)}
                                        />
                                    </div> */}
                                </div>
                                <div className="form-group">
                                    <div className="form-check">
                                        <input className="form-check-input" type="checkbox" id="invalidCheck" required />
                                        <label className="form-check-label" htmlFor="invalidCheck">Agree to <a href="#">terms and conditions</a></label>
                                    </div>
                                </div>
                                <button className="btn btn-primary" type="submit">Submit</button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>

            {/* MODAL EDIT ORDER */}
            <div className="modal fade" id="modalUpdateOrder" tabIndex={-1} role="dialog" style={{ display: 'none' }}>
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title h4" id="myLargeModalLabel">Edit order</h5>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close"><span>×</span></button>
                        </div>
                        <div className="modal-body">
                            <form id="formUpdateOrder" method="post" onSubmit={handleUpdate}>
                                <div className="form-row">
                                    <input type="hidden" name="id" value={id} />
                                    <div className="col-md-4 mb-3">
                                        <label htmlFor="ordersNum">Number</label>
                                        <input type="text" className="form-control" name="num" placeholder="Numero" required
                                            value={num}
                                            onChange={(e) => setNum(e.target.value)}
                                        />
                                    </div>
                                    <div className="col-md-4 mb-3">
                                        <label htmlFor="ordersDate">Date</label>
                                        <input type="date" className="form-control" name="date" required
                                            value={date}
                                            onChange={(e) => setDate(e.target.value)}
                                        />
                                    </div>
                                    {/* <div className="col-md-4 mb-3">
                                        <label htmlFor="ordersDiscount">Discount</label>
                                        <input type="number" className="form-control" name="discount" placeholder="Sconto" required 
                                            value={discount}
                                            onChange={(e) => setDiscount(e.target.value)}
                                        />
                                    </div> */}
                                </div>
                                <div className="form-group">
                                    <div className="form-check">
                                        <input className="form-check-input" type="checkbox" id="invalidCheck" required />
                                        <label className="form-check-label" htmlFor="invalidCheck">Agree to <a href="#">terms and conditions</a></label>
                                    </div>
                                </div>
                                <button className="btn btn-primary" type="submit">Submit</button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>

            {/* MODAL ORDER ITEMS */}
            <div className="modal fade" id="modalViewOrderItems" tabIndex={-1} role="dialog" style={{ display: 'none' }}>
                <div className="modal-dialog modal-xl">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title h4" id="myLargeModalLabel">Items order {num}</h5>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close"><span>×</span></button>
                        </div>
                        <div className="modal-body">
                            {okmessage && <ResponseDialog message={okmessage} onClose={() => setOKmessage("")} />}
                            <div className="table-responsive">
                                <table className="table">
                                    <thead>
                                        <tr>
                                            <th>Description</th>
                                            <th>Price</th>
                                            <th>Q.ty</th>
                                            <th>IN</th>
                                            <th>OUT</th>
                                            <th>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {orderItems.map((orderItem, index) => (
                                            orderItem = orderItem.node,
                                            <tr key={index}>
                                                <td className="text-wrap">{decodeStringFromUrl(orderItem.description)}</td>
                                                <td>{orderItem.price}</td>
                                                <td>{orderItem.quantity}</td>
                                                <td>{orderItem.price*orderItem.quantity}</td>
                                                <td>{roundTo(orderItem.price * (1 + (orderItem.percent / 100)), 0.5).toFixed(2)*orderItem.quantity}</td>
                                                <td>
                                                    <a href={decodeStringFromUrl(orderItem.trackingLink)} target="_blank" rel="noopener noreferrer">
                                                        <button type="button" className="btn m-0 p-0" data-toggle="tooltip" data-placement="top" data-original-title="View order items">
                                                            <span className="badge badge-pill badge-light-info"><span style={{ fontSize: '12px' }} className="material-symbols-outlined">link</span></span>
                                                        </button>
                                                    </a>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                    <tfoot>

                                    </tfoot>
                                </table>
                            </div>
                            <hr />
                            <form id="formAddOrderItem" method="post" onSubmit={handleCreateItem}>
                                <div className="form-row">
                                    <div className="col-md-12 mb-3">
                                        <input type="text" className="form-control" name="description" placeholder="Description" required
                                            value={description}
                                            onChange={(e) => setDescription(e.target.value)}
                                        />
                                    </div>
                                    <div className="col-md-4 mb-3">
                                        <input type="text" className="form-control" name="trackingNumber" placeholder="Tracking Number"
                                            value={trackingNumber}
                                            onChange={(e) => setTrackingNumber(e.target.value)}
                                        />
                                    </div>
                                    <div className="col-md-8 mb-3">
                                        <input type="text" className="form-control" name="trackingLink" placeholder="Tracking Link"
                                            value={trackingLink}
                                            onChange={(e) => setTrackingLink(e.target.value)}
                                        />
                                    </div>
                                    <div className="col-md-2 mb-3">
                                        <label htmlFor="quantity">Quantity</label>
                                        <input type="number" className="form-control" name="quantity" required min={1}
                                            value={quantity}
                                            onChange={(e) => setQuantity(e.target.value)}
                                        />
                                    </div>
                                    <div className="col-md-2 mb-3">
                                        <label htmlFor="price">Price</label>
                                        <input type="number" className="form-control" name="price" required min={0.01} step={0.01}
                                            value={price}
                                            onChange={(e) => setPrice(e.target.value)}
                                        />
                                    </div>
                                    <div className="col-md-2 mb-3">
                                        <label htmlFor="percent">Percent</label>
                                        <input type="number" className="form-control" name="percent" required
                                            value={percent}
                                            onChange={(e) => setPercent(e.target.value)}
                                        />
                                    </div>
                                    <div className="col-md-2 mb-3">
                                        <label htmlFor="delivered">Delivered</label>
                                        <input type="number" className="form-control" name="delivered" required
                                            value={delivered}
                                            onChange={(e) => setDelivered(e.target.value)}
                                        />
                                    </div>
                                    <div className="col-md-2 mb-3">
                                        <label htmlFor="collected">Collected</label>
                                        <input type="number" className="form-control" name="collected" required
                                            value={collected}
                                            onChange={(e) => setCollected(e.target.value)}
                                        />
                                    </div>
                                    <div className="col-md-2 mb-3">
                                        <label htmlFor="submit">.</label>
                                        <button className="btn btn-primary form-control" type="submit">Submit</button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
export default Orders;